import { Link } from "react-router-dom";
import { AuthContext, formatDate, formatTime } from "../util/api";
import { useContext } from "react";


export default function DoctorTable({ appointments }) {
  const styles = {
    wrapper: {
      width: "100%",
      padding: "20px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      background: "#f4f7fb",
      minHeight: "100vh",
    },

    card: {
      background: "#ffffff",
      borderRadius: "20px",
      padding: "20px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
      border: "1px solid rgba(0,0,0,0.05)",
      transition: "all 0.3s ease",
      animation: "fadeUp 0.5s ease",
    },

    topSection: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "15px",
      flexWrap: "wrap",
      marginBottom: "18px",
    },

    leftTop: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      flex: 1,
      minWidth: "220px",
    },

    rightTop: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "10px",
      minWidth: "140px",
    },

    appointmentId: {
      fontSize: "18px",
      fontWeight: "700",
      color: "#1d3557",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap",
    },

    dateText: {
      fontSize: "14px",
      color: "#6c757d",
      fontWeight: "500",
    },

    bodySection: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "16px",
      marginTop: "15px",
    },

    infoCard: {
      background: "#f8fbff",
      borderRadius: "14px",
      padding: "14px",
      border: "1px solid #e5edf7",
    },

    label: {
      fontSize: "12px",
      color: "#6c757d",
      marginBottom: "6px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      fontWeight: "600",
    },

    value: {
      fontSize: "15px",
      fontWeight: "600",
      color: "#1d3557",
      lineHeight: "1.5",
      wordBreak: "break-word",
    },

    buttonGroup: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      marginTop: "15px",
    },

    primaryBtn: {
      textDecoration: "none",
      background: "linear-gradient(135deg, #007bff, #0056b3)",
      color: "#fff",
      padding: "10px 18px",
      borderRadius: "12px",
      fontWeight: "600",
      fontSize: "14px",
      transition: "0.3s ease",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      boxShadow: "0 4px 12px rgba(0,123,255,0.25)",
    },

    secondaryBtn: {
      textDecoration: "none",
      background: "#eef4ff",
      color: "#0056b3",
      padding: "10px 18px",
      borderRadius: "12px",
      fontWeight: "600",
      fontSize: "14px",
      transition: "0.3s ease",
      border: "1px solid #d6e4ff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },

    badge: {
      padding: "8px 16px",
      borderRadius: "50px",
      fontSize: "13px",
      fontWeight: "700",
      textTransform: "capitalize",
      color: "#fff",
      letterSpacing: "0.3px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "110px",
    },

    statusCompleted: {
      background: "linear-gradient(135deg, #16a34a, #22c55e)",
    },

    statusPending: {
      background: "linear-gradient(135deg, #f59e0b, #fbbf24)",
    },

    statusCancelled: {
      background: "linear-gradient(135deg, #dc2626, #ef4444)",
    },

    chatCount: {
      background: "#fff",
      color: "#dc2626",
      padding: "2px 8px",
      borderRadius: "50px",
      fontSize: "12px",
      fontWeight: "700",
    },

    emptyState: {
      textAlign: "center",
      padding: "50px 20px",
      color: "#6c757d",
      fontSize: "18px",
      fontWeight: "500",
    },
  };
const {Doctor}  = useContext(AuthContext);
  return (
    <>
      <style>
        {`
          @keyframes fadeUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .doctor-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 15px 40px rgba(0,0,0,0.12);
          }

          .primary-btn:hover {
            transform: translateY(-2px);
            opacity: 0.95;
          }

          .secondary-btn:hover {
            background: #dce9ff;
          }

          @media (max-width: 768px) {
            .top-mobile {
              flex-direction: column !important;
              align-items: flex-start !important;
            }

            .right-mobile {
              width: 100%;
              align-items: flex-start !important;
            }

            .btn-mobile {
              width: 100%;
            }
          }
        `}
      </style>

      <div style={styles.wrapper}>
        {appointments.length > 0 ? (
          appointments.map((row, index) => (
            <div
              key={index}
              style={styles.card}
              className="doctor-card"
            >
              {/* Top Section */}
              <div style={styles.topSection} className="top-mobile">
                <div style={styles.leftTop}>
                  <div style={styles.appointmentId}>
                    Appointment #{row.id || "N/A"}
                  </div>

                  <div style={styles.dateText}>
                    Created on {formatDate(row.created_at)}
                  </div>
                </div>

                <div style={styles.rightTop} className="right-mobile">
                  <div
                    style={{
                      ...styles.badge,
                      ...(row.status === "completed"
                        ? styles.statusCompleted
                        : row.status === "pending"
                        ? styles.statusPending
                        : styles.statusCancelled),
                    }}
                  >
                    {row.status}
                  </div>
                </div>
              </div>

              {/* Body Section */}
              <div style={styles.bodySection}>
                <div style={styles.infoCard}>
                  <div style={styles.label}>   { Doctor.id !==  row.doctor_id ? "Lawyer" : `Client`} </div>
                  <div style={styles.value}>
                    

                     {  Doctor.id !==  row.doctor_id ?  row.doctor?.name || "N/A"  :     row.patient?.name || "N/A"} 


                  </div>
                </div>

                <div style={styles.infoCard}>
                  <div style={styles.label}>Appointment Schedule</div>

                  <div style={styles.value}>
                    {row.parent_appointment_id === null ? (
                      <>
                        {row.day}
                        <br />
                        {formatTime(row.starttime)} -{" "}
                        {formatTime(row.endtime)}
                      </>
                    ) : (
                      <>
                        {formatDate(row.starttime)}{" "}
                        {formatTime(row.starttime)}
                        <br />
                        {formatDate(row.endtime)}{" "}
                        {formatTime(row.endtime)}
                      </>
                    )}
                  </div>
                </div>

                <div style={styles.infoCard}>
                  <div style={styles.label}>Appointment Type</div>

                  <div style={styles.value}>
                    {row.parent_appointment_id !== null
                      ? "Follow-up Appointment"
                      : "Primary Appointment"}
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div style={styles.buttonGroup}>
                <Link
                  to={ row.status === "pending" ?  `/payment_options/${row.id}` :`/appointment/${row.id}`  }
                  style={styles.primaryBtn}
                  className="primary-btn btn-mobile"
                >
                  {row.status === "pending"
                    ? "Make Payment"
                    : "View Appointment"}

                  {row.unseen_chat_box_count > 0 && (
                    <span style={styles.chatCount}>
                      ✉️ {row.unseen_chat_box_count}
                    </span>
                  )}
                </Link>

                {row.parent_appointment_id !== null && (
                  <Link
                    to={`/appointment/${row.parent_appointment_id}`}
                    style={styles.secondaryBtn}
                    className="secondary-btn btn-mobile"
                  >
                    Related Appointment
                  </Link>
                )}
              </div>
            </div>
          ))
        ) : (
          <div style={styles.emptyState}>
            No appointments available
          </div>
        )}
      </div>
    </>
  );
}